import { createBrowserRouter, replace, type RouterState } from 'react-router-dom';
import App, { VisitorVisaScreen } from '@/App';
import { entryPath, routeOf, PORTAL_ROUTES } from '@/lib/route';
import { installNavigator } from '@/lib/navigator';
import { getMyWorkTab, rememberMyWorkTab } from '@/hooks/useMyWorkTab';
import { setTicketFocus, setTaskFocus } from '@/hooks/useWorkFocus';

const toEntry = ({ request }: { request: Request }) => replace(entryPath(new URL(request.url).search, getMyWorkTab()));

export const router = createBrowserRouter([
  { path: '/visitor-visa/*', element: <VisitorVisaScreen /> },
  {
    path: '/',
    element: <App />,
    HydrateFallback: () => null,
    children: [
      { index: true, loader: toEntry },
      ...PORTAL_ROUTES,
      { path: '*', loader: toEntry },
    ],
  },
]);

installNavigator(router);

/* A case or a task named by the address — a cold link, Back, Forward — is
   asked for by id, so it opens even when it is not on this person's board. */
let seen = '';
function followRoute({ navigation, location, matches }: RouterState) {
  if (navigation.state !== 'idle' || location.key === seen) return;
  seen = location.key;
  const r = routeOf(matches.map((m) => ({ handle: m.route.handle, params: m.params })));
  if (r?.mwTab) rememberMyWorkTab(r.mwTab);
  if (r?.caseId) setTicketFocus(r.caseId);
  if (r?.taskId) setTaskFocus(r.taskId);
}
router.subscribe(followRoute);
followRoute(router.state);
